import { Component, Input, OnInit } from '@angular/core';
import { GeneralStatusService } from '../../services/general-status.service';
// import { ServerStats } from '../../models/os-info.data';

interface ServerStats {
  totalMemoryMB: string;
  usedMemoryMB: string;
  memoryUsagePercentage: string;
  cpuUsagePercentage: string;
  networkUsage: string;
  diskUsagePercentage: string;
  mysqlStats: MySQLStats;
  incidents: number;
  incidents_sended: number;
  incidents_actives: number;
  incidents_archived: number;
  installations: number;
  dashboards: number;
  cuadros: number;
  subsecciones: number;
}

interface MySQLStats {
  connections: number;
  abortedConnects: number;
  queries: number;
}

@Component({
  selector: 'app-current-info',
  standalone: true,
  imports: [],
  templateUrl: './current-info.component.html',
  styleUrl: './current-info.component.scss',
})
export class CurrentInfoComponent implements OnInit {
  currentInfo?: ServerStats;

  constructor(private service: GeneralStatusService) {}

  ngOnInit(): void {
    this.getCurrentInfo();

    setTimeout(() => {
      this.getCurrentInfo();
    }, 60000);
  }

  getCurrentInfo() {
    this.service.getServerStats().subscribe((res) => {
      this.currentInfo = res;
    });
  }
}
